import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type LanguagePackContextDataFragment = (
  { __typename: 'LanguagePack' }
  & Pick<SchemaTypes.LanguagePack, 'id' | 'displayName' | 'orientation'>
);

export const LanguagePackContextDataFragmentDoc = /*#__PURE__*/ gql`
    fragment LanguagePackContextData on LanguagePack {
  id
  displayName
  orientation
}
    `;